/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent } from 'react'
import { Link } from '@reach/router'
import { styles } from './styles'

export const Footer: FunctionComponent = () => (
  <div css={styles.container}>
    <div css={styles.section}>
      <h5 css={styles.title}>PartScout.me</h5>
      <span css={styles.subtitle}>© {new Date().getFullYear()} Karma Fixer LLC</span>
    </div>

    <div css={styles.section}>
      <h5 css={styles.title}>Legal</h5>

      <a href="#" css={styles.item}>
        Terms of Use
      </a>
      <a href="#" css={styles.item}>
        Privacy Policy
      </a>
      <a href="#" css={styles.item}>
        Cookies
      </a>
    </div>

    <div css={styles.section}>
      <h5 css={styles.title}>Links</h5>

      <Link to="/requests/new" css={styles.item}>
        New request
      </Link>

      <Link to="/requests" css={styles.item}>
        Requests
      </Link>
    </div>
  </div>
)
